<template>
  <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";
import { color } from "@/util/util";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      // this.setOptions(this.chartData || {});
    },
    setOptions(data) {
      let _this = this;
      this.chart.setOption({
        tooltip: {
          trigger: "item",
          backgroundColor:'rgba(255,255,255,1)'
        },
        legend: {
          show: true,
          left: "40%",
          y: "center",
          //   width: "40%",
          orient: "vertical",
          align: "auto",
          borderRadius: "50%",
          itemGap: 20,
          textStyle: {
            color:_this.isbig ? "#AABEFF" : "",
            rich: {
              a: {
                width: 150,
                // fontSize: 20,
                // verticalAlign: "top",
                // align: "center",
              },
              b: {
                width: 100,
                // fontSize: 14,
                // align: "center",
                // padding: [0, 10, 0, 0],
                // lineHeight: 25,
              },
              c: {
                width: 200,
              },
            },
          },
          formatter: function (name) {
            // return name + "28.79％" + "555";
            // if(name == "助残助盲"){
            //   return `{a|${name}}{b|12.5%}{c|1}`;
            // }
            // if(name == "志愿服务"){
            //   return `{a|${name}}{b|87.5%}{c|7}`;
            // }
            for(var key in data.data){
              if(data.data[key].value!=0&&data.data[key].name==name){
                return `{a|${name}}{b|${data.data[key].proportion}%}{c|${data.data[key].value}}`;
              }
            }
            return `{a|${name}}{b|0%}{c|0}`;
          },
        },
        series: [
          {
            name: "工作信息统计",
            type: "pie",
            radius: ["85%", "68%"],
            center: ["20%", "50%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 0,
              // borderColor: '#fff',
              borderColor: _this.isbig ? "#1E3990" : "#fff",
              borderWidth: 2,
            },
            label: {
              normal: {
                show: true,
                position: "center",
                color: "#4c4a4a",
                formatter:
                  "{total|信息总量}" + "\n\r" + "{active|" + data.sum + "}",
                rich: {
                  total: {
                    fontSize: 20,
                    lineHeight: 30,
                    // color: '#454c5c'
                    color: _this.isbig ? "#AABEFF" : "",
                  },
                  active: {
                    fontSize: 16,
                    // color: '#6c7a89',
                    color: _this.isbig ? "#AABEFF" : "",
                    lineHeight: 40, 
                  },
                },
              },
              emphasis: {
                //中间文字显示
                show: true,
              },
            },
            lableLine: {
              normal: {
                show: false,
              },
              emphasis: {
                show: true,
              },
              tooltip: {
                show: false,
              },
            },

            // label: {
            //     show: true,
            //     position: 'center',
            //     fontSize:18,
            //     formatter: '{a}\n\n{c}'
            // },
            // emphasis: {
            //     scale:false,
            //     label: {
            //         show: false
            //     }
            // },
            // labelLine: {
            //     show: false
            // },
            data: data.data,
          },
        ],
      });
    },
  },
};
</script>
